export type { IconProps } from "./Icon";
export type { IconPreset } from "./Icon.presets";
export type { CustomIcon, IconType } from "./Icon.types";
export { isIcon } from "./Icon.utils";

import Icon from "./Icon";
import { iconMap } from "./Icon.presets";

export default Object.assign(Icon, iconMap);
